export default "__VITE_ASSET__qutNgRoK__"